
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Contact from "../shared/Contact";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import ContentTitle from "../shared/ContentTitle";
import * as ReactRouterDom from "react-router-dom";
import { Debugger, CacheManager, Utils } from "../../utils";
import LoadingGif from "../../assets/images/loading_circle.gif";
import { Accordion, AccordionTab, PanelFixtureOptions } from "@ronuse/noseur";
import { ApiResponseData, IPlatform, FaqService, SanitizedResponse, IFaq } from "../../services";

function Faq() {
    const labels = i18nManager.Labels.faqs;
    const faqService = FaqService.getInstance();
    const { platform } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const [faqs, setFaqs] = React.useState<ApiResponseData<IFaq>>({});
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams();

    React.useEffect(() => {
        if (!activePlatform) return;
        faqService.queryFaqs({ sort: "id,ASC", "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("Faq:useEffect:queryFaqs", apiResponse.data);
            setFaqs(apiResponse.data!);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={labels.title} />
        <Breadcrumb breadCrumbs={[{ label: labels.title, location: "/faqs" }]} />
        <ContentTitle title={labels.long_title} />
        {(!faqs.content) && (<img alt={`Loading faqs`} src={LoadingGif} style={{ margin: "10% auto", height: 90, width: 90 }} />)}
        <Accordion className="faqs" borderless onTabCollapse={() => {
            console.log("----", window.location.pathname);
            window.history.pushState("", document.title, window.location.pathname + window.location.search);
        }} >
            {faqs.content?.map((faq) => (<AccordionTab key={faq.external_id} collapsed={false} collapsibleIcons={Utils.COLLAPSIBLE_ICONS} header={(options?: PanelFixtureOptions) => {
                return (<a key={faq.external_id} href={`?id=${faq.external_id}`} className="section-title" style={!options?.collapsed ? { borderBottom: "none" } : undefined} onClick={(e) => {
                    e.preventDefault();
                    options?.onToggle();
                }}>
                    <span>{faq.title}</span> {options?.toggleElement as any}
                </a>)
            }} ref={(e: any) => {
                if (searchParams.get("id") === faq.external_id) e?.scrollIntoView?.();
            }} manageRef={(e: any) => {
                if (searchParams.get("id") === faq.external_id) e?.expand();
            }} borderless>
                {faq.content}
            </AccordionTab>))}
        </Accordion>
        <Contact />
        <Footer />
    </div>);
}

export default Faq;
